var map = {
	"./en-US": [
		"743d",
		"lang-en-US"
	],
	"./en-US.js": [
		"743d",
		"lang-en-US"
	],
	"./en-US/menu": [
		"771d",
		"lang-en-US-menu"
	],
	"./en-US/menu.js": [
		"771d",
		"lang-en-US-menu"
	],
	"./en-US/setting": [
		"5030",
		"lang-en-US-setting"
	],
	"./en-US/setting.js": [
		"5030",
		"lang-en-US-setting"
	],
	"./zh-CN": [
		"2807"
	],
	"./zh-CN.js": [
		"2807"
	],
	"./zh-CN/menu": [
		"1dec"
	],
	"./zh-CN/menu.js": [
		"1dec"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "4aa4";
module.exports = webpackAsyncContext;